"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _default = {
  DateTimeFormat: {
    shortDate: 'MM/DD/YYYY',
    shortTime: 'HH:mm',
    shortTimeAMPM: 'hh:mm A',
    longTimeAMPM: 'hh:mm AA',
    shortDayOfWeek: 'ddd',
    dayOfWeek: 'dddd',
    shortMonth: 'MMMM YYYY',
    // date time format with AM PM
    dateTimeAMPM: 'MM/DD/YYYY hh:mm A',
    dateTimeShortYearAMPM: 'MM/DD/YY hh:mm A',
    longDateFormat: 'MMMM DD, YYYY',
    longDayOfWeekFormat: 'dddd, MMMM DD, YYYY',
    longDateTimeFormat: 'MMMM DD, YYYY hh:mm A',
    // Short date, year
    shortYear: 'MM/DD/YY'
  },
  IgnoreCachedTimezone: true,
  TimeConstraint: {
    minutes: {
      step: 30,
      min: 0
    },
    startTime: {
      hours: 9,
      minutes: 0,
      seconds: 0
    },
    endTime: {
      hours: 17,
      minutes: 0,
      seconds: 0
    }
  },
  FILTER_RANGES_NAME: {
    CUSTOM_RANGE: 'Custom Range',
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAY: 'Last 7 Days',
    LAST_30_DAY: 'Last 30 Days',
    THIS_MONTH: 'This Month',
    LAST_MONTH: 'Last Month',
    THIS_YEAR: 'This year'
  },
  ConfigDateRangeMenuPicker: {
    maxDate: (0, _momentTimezone.default)().startOf('day'),
    minDate: (0, _momentTimezone.default)().subtract(1, 'year').add(1, 'day'),
    dateFrom: (0, _momentTimezone.default)().startOf('day'),
    dateTo: (0, _momentTimezone.default)().endOf('day'),
    initialVisibleMonth: (0, _momentTimezone.default)().subtract(1, 'month').startOf('month'),
    // The maximum span between the selected start and end dates.
    rangeLimit: {
      days: 364
    },
    filterRanges: {
      Today: [(0, _momentTimezone.default)().startOf('day'), (0, _momentTimezone.default)().endOf('day')],
      Yesterday: [(0, _momentTimezone.default)().startOf('day').subtract(1, 'days'), (0, _momentTimezone.default)().endOf('day').subtract(1, 'days')],
      'Last 7 Days': [(0, _momentTimezone.default)((0, _momentTimezone.default)().startOf('day')).subtract(6, 'days'), (0, _momentTimezone.default)().endOf('day')],
      'Last 30 Days': [(0, _momentTimezone.default)((0, _momentTimezone.default)().startOf('day')).subtract(29, 'days'), (0, _momentTimezone.default)().endOf('day')],
      'This Month': [(0, _momentTimezone.default)().startOf('month'), (0, _momentTimezone.default)().endOf('day')],
      'Last Month': [(0, _momentTimezone.default)().subtract(1, 'month').startOf('month'), (0, _momentTimezone.default)().subtract(1, 'month').endOf('month')],
      'This Year': [(0, _momentTimezone.default)().startOf('year'), (0, _momentTimezone.default)().endOf('day')]
    }
  }
};
exports.default = _default;